<template>
  <div>
    <v-list>
      <v-list-group v-for="analysis in list" :key="analysis.name" no-action>
        <v-list-tile slot="activator">
          <v-list-tile-title>
            {{ analysis.name }}
          </v-list-tile-title>
          <v-list-tile-sub-title
          >
          Material:<strong> {{ analysis.material}}</strong>
          </v-list-tile-sub-title>
          <v-list-tile-sub-title
          >
          Recalculation: <strong>{{ analysis.recalculation|format-date-time  }}</strong>
          </v-list-tile-sub-title>
        </v-list-tile>

        <v-list-item>
          <v-list-item-content>
            <template>
              <table style="width:100%">
                  <thead>
                    <tr>
                      <th>Simbolo</th>
                      <th class="text-left">Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="element in analysis.analysis_elements" :key="element.id">
                      <td class="text-center">{{ element.symbol }}</td>
                      <td>{{ element.value }}</td>
                    </tr>
                  </tbody>
              </table>
            </template>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>

  </div>
</template>

<script>
import formMixin from '@/mixins/formMixin'
import mutationsMixin from '@/mixins/mutationsMixin'

export default {
  props: ['analysisList'],
  mixins: [formMixin, mutationsMixin],
  data () {
    return {
      list: this.analysisList
    }
  }
}
</script>

<style>
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/partials/AnalysisForm.vue